module.exports = __webpack_public_path__ + "media/audio-coins.b59a1c73.mp3";